import React, { useState, useEffect } from "react";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { Row, Col, Card, Form } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RenderDeleteModal from "../../../components/partials/components/delete-modal";
import ToastNotification from "../../../components/Toast";
import {
  API_SERVER_MANAGEMENT_LIST,
  API_SERVER_MANAGEMENT_DELETE,
} from "../../../service/url";
import { ROUTES, MODULE_ACL } from "../../../utilities/constant";
import { EditIcon, DeleteIcon } from "../../../components/setting/elements";
import Loader  from '../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { USER_ROLES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import exportData from '../../../utilities/export';
import { toast } from "react-toastify"

const ServerManagementList = () => {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [enableDeleteModal, setEnableDeleteModal] = useState(false);
  const [deleteServerManagementId, setDeleteServerManagementId] = useState(undefined);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [serverManagement, setserverManagement] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
  const [moduleOperations, setModuleOperations] = useState({});
  const [selectedServers, setSelectedServers] = useState([]);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [searchValue, setSearchValue] = useState(null);
  const [originalDataList, setOriginalDataList] = useState([]);

  const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "gateway-management-list",
         data: serverManagement,
         columns: [
            {
               header: "Data Center",
               accessor: (row) =>
                  row.data_center?.name || "-"
            },
            {
               header: "Type",
               accessor: (row) =>
                  row.type || "-"
            },
            {
               header: "Gateway IP",
               accessor: (row) =>
                  row.server_ip || "-"
            },
            {
               header: "Gateway Name",
               accessor: (row) =>
                  row.server_name || "-"
            },
            {
               header: "OS",
               accessor: (row) =>
                  row.os || "-"
            },
            {
               header: "CPU Cores",
               accessor: (row) =>
                  row.cpu_cores || "-"
            },
            {
               header: "RAM",
               accessor: (row) =>
                  row.ram || "-"
            },
            {
               header: "Hard Disk",
               accessor: (row) =>
                  row.hard_disk || "-"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.createdAt).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Updated Date",
               accessor: (row) =>
                  new Date(row.updatedAt).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

  const handleCheckboxToggle = (serverId) => {
    const isSelected = selectedServers.includes(serverId);
    setSelectedServers(isSelected
        ? selectedServers.filter(id => id !== serverId)
        : [...selectedServers, serverId]);
  };

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
  
    useEffect(() => {
      const user = getUser();
        if (user) {
          if (user?.acl_settings) {    
            setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
          }
        }
    }, []);

  const handleMultiDelete = () => {
        setIsMultiDelete(true);
        setEnableDeleteModal(true);
  };

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    setLoading(true);
    getApiCall(API_SERVER_MANAGEMENT_LIST)
      .then(onServerManagementSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const user = getUser();
      if (user) {
        if (user.role === USER_ROLES.SUPERADMIN) {
          checkIsSuperAdmin(true);
        }
        if (user?.acl_settings) {
          setModuleOperations(JSON.parse(user.acl_settings.module_operations));
        }
      }
  }, []);

  useEffect(() => {
    const onAclRefreshed = () => {
      const user = getUser();
      if (user?.acl_settings?.module_operations) {
        try {
          const parsed = typeof user.acl_settings.module_operations === "string"
            ? JSON.parse(user.acl_settings.module_operations)
            : user.acl_settings.module_operations;
          setModuleOperations(parsed);
          setModuleOperationsForReadPermissionCheck(parsed);
        } catch (e) {
          console.log("Failed to apply refreshed ACL", e);
        }
      }
    };
    window.addEventListener("acl-refreshed", onAclRefreshed);
    return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
  }, []);


  function onServerManagementSuccess(resp) {
    const updatedList = resp.map((val, idx) => {
      val["key"] = idx + 1;
      val["actions"] = RenderActionComponent(val.id);
      val["createdAt"] = new Date(val["createdAt"]).toGMTString();
      return val;
    });
    setserverManagement(updatedList);
    setOriginalDataList(updatedList);
  }
  

  useEffect(() => {
    if (searchValue) {
      const lowerSearch = searchValue.trim().toLowerCase();
      setserverManagement(
        originalDataList.filter((data) =>
          data.server_name?.toLowerCase().includes(lowerSearch) ||
          data.server_ip?.toLowerCase().includes(lowerSearch) ||
          data.os?.toLowerCase().includes(lowerSearch) ||
          data.type?.toLowerCase().includes(lowerSearch)
        )
      );
    } else {
      setserverManagement(originalDataList);
    }
  }, [searchValue, originalDataList]);
  
  

  const RenderActionComponent = ({id}) => {
    const serverManagementEditRoute = ROUTES.SERVER_MANAGEMENT.EDIT.replace(
      ":id",
      id
    );
    return (
      <div className="flex align-items-center list-user-action">
        {(isSuperAdmin || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.edit) && (
          <EditIcon linkTo={`/${serverManagementEditRoute}`} />
        )}{" "}
        {(!(selectedServers.length > 0) && (isSuperAdmin || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.delete)) && (
          <DeleteIcon handleCallback={() => handleServerManagementDelete(id)} />
        )}{" "}
      </div>
    );
  }
  function handleServerManagementDelete(id) {
    checkAuth(setToastProps, setShowToast)
    setIsMultiDelete(false);
    setEnableDeleteModal(true);
    setDeleteServerManagementId(id);
  }

  const handleSelectAll = () => {
    if (selectedServers.length === serverManagement.length) {
        setSelectedServers([]);
    } else {
        const allServerIds = serverManagement.map(server => server.id);
        setSelectedServers(allServerIds);
    }
  };

  useEffect( () => {
  if (confirmDelete) {
      if (isMultiDelete) {
          postApiCall(API_SERVER_MANAGEMENT_DELETE, { serverIds: selectedServers })
              .then(onDeleteSuccess)
              .catch(onDeleteFail);
      } else {
          postApiCall(API_SERVER_MANAGEMENT_DELETE, { serverIds: [deleteServerManagementId] })
              .then(onDeleteSuccess)
              .catch(onDeleteFail);
      }
  }
  }, [confirmDelete]);

  function onDeleteSuccess(resp) {
    // setToastProps({
    //   type: "success",
    //   message: "Server Managemnet deleted successfully",
    // });
          toast.success("Gateway deleted successfully");
      let updatedList;
      if (isMultiDelete) {
         updatedList = serverManagement.filter(val => !selectedServers.includes(val.id)).map((val, key) => {
            val['key'] = key + 1;
            return val;
         });
         setSelectedServers([]);
      } else {
         updatedList = serverManagement
         .filter((val) => val.id != deleteServerManagementId)
         .map((val, key) => {
           val["key"] = key + 1;
           return val;
         });
      }
    setserverManagement(updatedList);
    setEnableDeleteModal(false);
    setDeleteServerManagementId(undefined);
    setConfirmDelete(false); 

    setLoading(true);
    getApiCall(API_SERVER_MANAGEMENT_LIST)
      .then(onServerManagementSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
  }

  function onDeleteFail(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
    // setToastProps({
    //   type: "danger",
    //   message: `Unable to delete Server Management: ${err}`,
    // });
          toast.error(`Unable to delete Gateway: ${err}`);
   }
   setConfirmDelete(false); 
  }

  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     console.log(err)
   }
 }

 const handleCreateButtonClick = () => {
  navigate(`/${ROUTES.SERVER_MANAGEMENT.CREATE}`);
} 

 const rowClassName = (data) => {
  return {
      'highlighted-row': selectedServers.includes(data.id)
    };
  };

  const actionBodyTemplate = (rowData) => {
    return <RenderActionComponent id={rowData.id} />;
};

  if (loading) {
    return <Loader />
 }

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Gateway Management List</h4>
              </div>
              {(isSuperAdmin || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.add) && (
                <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>
                  Create Gateway
                </button>
              )}
            </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive border-bottom my-3">
                <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                   {((isSuperAdmin || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.delete)) && (
                      <Button 
                        label="Delete Selected" 
                        onClick={handleMultiDelete} 
                        className="p-button-danger p-button-sm" 
                        style={{ marginBottom: '10px', marginLeft: '10px' }} 
                        disabled={selectedServers.length === 0} 
                      />
                   )}
                  {serverManagement.length > 0 &&
                    <Button 
                    label="Export Data" 
                    onClick={handleExport} 
                    className="p-button-active p-button-sm" 
                    style={{ marginBottom: '10px', marginLeft: '10px' }} 
                    disabled={buttonDisable} 
                  >
                    &nbsp;
                    {buttonDisable && (
                      <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                    )}
                  </Button>
                  }

                  <Form.Group style={{height: "45px"}}>
                    <Form.Control
                      style={{height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px"}}
                      placeholder = 'Search by Gateway Name...'
                      type="text"
                      maxLength={100}
                      value={searchValue} 
                      onChange={(e) => setSearchValue(e.target.value)}
                      required
                    />
                  </Form.Group>
                  </div>
                  <div className="scroll-container">
                    <DataTable
                      value={serverManagement}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                      rowClassName={rowClassName}
                    >
                      <Column 
                        header={<Checkbox 
                        checked={selectedServers.length === serverManagement.length && serverManagement.length > 0} 
                        onChange={handleSelectAll} 
                        />} 
                        headerStyle={{ width: '3rem' }} 
                        body={(rowData) => (
                          <Checkbox 
                            checked={selectedServers.includes(rowData.id)} 
                            onChange={() => handleCheckboxToggle(rowData.id)} 
                          />
                          )} 
                        />
                      <Column
                        field="data_center.name"
                        filterField="data_center.name"
                        header="Data Center"
                        filter
                        filterPlaceholder="search by Data Center"
                      ></Column>

                      <Column
                        field="type"
                        filterField="type"
                        header="Type"
                        filter
                        filterPlaceholder="search type"
                      ></Column>
                      <Column
                        field="server_ip"
                        filterField="server_ip"
                        header="Gateway IP"
                        filter
                        filterPlaceholder="search Gateway ip"
                      ></Column>
                      <Column
                        field="server_name"
                        filterField="server_name"
                        header="Gateway Name"
                        filter
                        filterPlaceholder="search by Gateway name"
                      ></Column>
                      <Column
                        field="os"
                        filterField="os"
                        header="OS"
                        filter
                        filterPlaceholder="search OS"
                      ></Column>
                      <Column
                        field="cpu_cores"
                        filterField="cpu_cores"
                        header="CPU Cores"
                        filter
                        filterPlaceholder="search CPU Cores"
                      ></Column>
                      <Column
                        field="ram"
                        filterField="ram"
                        header="RAM"
                        filter
                        filterPlaceholder="search RAM"
                      ></Column>
                      <Column
                        field="hard_disk"
                        filterField="hard_disk"
                        header="Hard Disk"
                        filter
                        filterPlaceholder="search Hard Disk"
                      ></Column>
                      <Column field="createdAt" header="Created Date" body={(rowData) =>
                                    new Date(rowData.createdAt).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column field="updatedAt" header="Updated Date" body={(rowData) =>
                                    new Date(rowData.updatedAt).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                      {((isSuperAdmin || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.edit || moduleOperations?.[MODULE_ACL.GATEWAY_MANAGEMENT]?.delete)) && (
                      <Column header="Action" body={actionBodyTemplate} />
                      )}
                    </DataTable>
                  </div>  
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <RenderDeleteModal 
         show={enableDeleteModal} 
         setShow={setEnableDeleteModal} 
         setConfirmDelete={setConfirmDelete} 
         isMultiDelete={isMultiDelete} 
         clearSelectedData={() => setSelectedServers([])}
      />

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default ServerManagementList;
